import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers/internalApi";
import type { Post } from "@/react/types/Post";
import { Typography } from "@circle-react-uikit/Typography";
import { AiAgentAvatar } from "../../../AiAgentAvatar";
import { useIsAiAutomationsV2Enabled } from "../renamePostTitle/useIsAiAutomationsV2Enabled";

export interface HistoryDetailViewPostHiddenFromFeaturedAreasProps {
  body: {
    community_bot_profile_id: number;
  };
  log: {
    message: {
      response_details: {
        body: {
          post_id: number;
          space_slug: string;
          post_slug: string;
        };
      };
    };
  };
}

export const HistoryDetailViewPostHiddenFromFeaturedAreas = ({
  body,
  log,
}: HistoryDetailViewPostHiddenFromFeaturedAreasProps) => {
  const isAiAutomationV2Enabled = useIsAiAutomationsV2Enabled();

  const { community_bot_profile_id: communityBotProfileId } = body;
  const { space_slug: spaceSlug, post_slug: postSlug } =
    log.message.response_details?.body ?? {};

  const { data: post, isLoading } = useQuery<Post>({
    queryKey: ["posts", log.message.response_details?.body?.post_id ?? null],
    queryFn: () =>
      reactQueryGet(
        internalApi.posts.show({
          postSlug,
          spaceSlug,
        }),
      ),
    retry: false,
    enabled: !!log.message.response_details?.body?.post_id,
  });

  return (
    <div className="flex flex-col gap-2">
      {!isAiAutomationV2Enabled && (
        <div className="md:flex">
          <div className="w-1/4">
            <Typography.LabelSm weight="semibold">
              {t("settings.workflows.action_messages.ai_agents.ai_agent")}
            </Typography.LabelSm>
          </div>
          <div className="w-3/4">
            <AiAgentAvatar communityBotProfileId={communityBotProfileId} />
          </div>
        </div>
      )}
      <div className="md:flex">
        <div className="w-1/4">
          <Typography.LabelSm weight="semibold">
            {t("settings.workflows.action_messages.ai_agents.post")}
          </Typography.LabelSm>
        </div>
        <div className="w-3/4">
          {post ? (
            <a
              href={`/c/${spaceSlug}/${postSlug}`}
              target="_blank"
              className="text-sm"
              rel="noopener noreferrer"
            >
              {t("settings.workflows.action_messages.ai_agents.post_link")}
            </a>
          ) : (
            <Typography.LabelSm>
              {t(
                `settings.workflows.action_messages.ai_agents.${isLoading ? "post_loading" : "post_not_found"}`,
              )}
            </Typography.LabelSm>
          )}
        </div>
      </div>
    </div>
  );
};
